import { useAction } from '@src/redux/hooks/useAction';
import { useSelect } from '@src/redux/hooks/useSelect';

import { setIsEditing } from './actions';

const editingSelector = (state) => {
  return state.editing;
};

export const useEditing = {
  state: () => {
    return useSelect(editingSelector);
  },
  actions: () => {
    return {
      setIsEditing: useAction(setIsEditing),
    };
  },
};
